import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { adminApi } from "./adminApi";
import { Logo } from "@/components/landing/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);
  const [denied, setDenied] = useState(null);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", location.pathname);
    adminApi.post("/auth/session", { session_id: sessionId })
      .then(({ data }) => navigate("/area-riservata", { replace: true, state: { user: data } }))
      .catch((e) => {
        if (e.response?.status === 403) setDenied(e.response.data?.detail?.email || "questo account");
        else navigate("/area-riservata", { replace: true });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-[#F4F3EC] grid place-items-center px-6" data-testid="auth-callback">
      {denied ? (
        <div className="max-w-md text-center" data-testid="auth-denied">
          <div className="flex justify-center"><Logo /></div>
          <p className="f-serif text-4xl text-[#1B3B28] mt-10">Accesso riservato allo staff</p>
          <p className="text-[#526356] mt-4">L'account <b>{denied}</b> non è autorizzato. Chiedi al Dott. Mauro di aggiungerti nella sezione Staff dell'area riservata.</p>
          <a href="/" className="inline-block mt-8 text-sm text-[#1B3B28] border-b border-[#1B3B28]/30 pb-1" data-testid="auth-denied-home-link">Torna al sito</a>
        </div>
      ) : <Loader2 className="animate-spin text-[#3E6B48]" />}
    </div>
  );
}
